import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { selectCustomerWsToken, openCustomerWS, subscribeLastBetUpdateWs } from "@nxplatform/customer/slices/customer.slice";
import { selectGrpcIsActive } from "@nxplatform/platform-settings/locale-setup.selectors";
import { stopPublicWsConnection, startPublicWsConnection } from "@service/api-client/slices";
import { clientsWs } from "@service/api-client/websockets/ws-clients";
const useWsConnection = ({
  wsActive,
  loaded,
  publicWsAliveChannels,
  wsEndpoint,
  fullSettingsLoaded,
  initialClientsInitialized = false
}) => {
  const dispatch = useDispatch();
  const aliveRef = useRef(null);
  const isProtoBuf = useSelector(selectGrpcIsActive);
  const customerWsToken = useSelector(selectCustomerWsToken);
  const [clientsInitialized, setClientsInitialized] = useState(initialClientsInitialized);
  const store = useStore();
  useEffect(() => {
    if (!fullSettingsLoaded) {
      return;
    }
    let lastToInit = clientsWs.length;
    clientsWs.forEach(async (item) => {
      const { key, client } = item;
      await store.apiManager.addWsApi(key, client, isProtoBuf);
      lastToInit -= 1;
      if (lastToInit === 0) {
        setClientsInitialized(true);
      }
    });
  }, [fullSettingsLoaded, isProtoBuf]);
  useEffect(() => {
    return () => {
      dispatch(stopPublicWsConnection());
    };
  }, []);
  useEffect(() => {
    const aliveString = JSON.stringify(publicWsAliveChannels);
    const firstEmpty = (ref, current) => ref === null && current.length === 0;
    if (wsEndpoint && wsActive && loaded && aliveString !== aliveRef.current && !firstEmpty(aliveRef.current, publicWsAliveChannels) && clientsInitialized) {
      aliveRef.current = aliveString;
      dispatch(startPublicWsConnection({ channels: publicWsAliveChannels, isProtoBuf }));
    }
  }, [JSON.stringify(publicWsAliveChannels), wsActive, loaded, wsEndpoint, clientsInitialized]);
  useEffect(() => {
    if (customerWsToken && clientsInitialized) {
      dispatch(openCustomerWS(customerWsToken));
      dispatch(subscribeLastBetUpdateWs());
    }
  }, [customerWsToken, clientsInitialized, dispatch]);
};
export {
  useWsConnection
};
